import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { getCertificationList } from '../../slices/ManageCompliance/manageComplianceSlice';
import { addProjectCertificationAPI } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getProjectCertifications } from '../../slices/ManageClient/thunk';

export default function AddCertificationModal(
    { addCertificateModal, toggleAddCertificateModal, defaultCertificate }
) {
    const dispatch = useDispatch();
    const params = useParams();
    const CLIENT_ID = params.id;

    const [formData, setFormData] = useState({
        clientId: params.id,
        startDate: '',
        dueDate: '',
        versionId: ''
    });

    const [submittingForm, setSubmittingForm] = useState(false); // submittingForm state

    useEffect(() => {
        dispatch(getCertificationList());
    }, [dispatch, params.id]);

    const handleDateChange = (name, date) => {
        setFormData(prevState => ({
            ...prevState,
            [name]: date[0]
        }));
    };

    const handleRadioChange = (id) => {
        setFormData(prevState => ({
            ...prevState,
            versionId: (id)
        }));
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();

            if (submittingForm) return;

            const { startDate, dueDate, versionId } = formData;

            if (!startDate) {
                toast.error("Start Date is required.");
                return;
            }

            if (!dueDate) {
                toast.error("Due Date is required.");
                return;
            }

            if (!versionId) {
                toast.error("Please select a certification.");
                return;
            }

            const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : '';
            const formattedDueDate = dueDate ? moment(dueDate).format('YYYY-MM-DD') : '';

            const dataToSubmit = {
                ...formData,
                startDate: formattedStartDate,
                dueDate: formattedDueDate,
            };

            setSubmittingForm(true);
            const apiResponse = await addProjectCertificationAPI(dataToSubmit);
            if (apiResponse.status === 201) {
                toast.success(apiResponse.data);
                handleReset();
                toggleAddCertificateModal();
                dispatch(getProjectCertifications(CLIENT_ID));
            } else if (apiResponse.status === 409) {
                toast.error(apiResponse.data);
            } else {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding certification');
        } finally {
            setSubmittingForm(false);
        }
    };

    const handleReset = () => {
        setFormData({
            clientId: params.id,
            startDate: null,
            dueDate: null,
            versionIds: []
        });
    };


    return (
        <>
            <Modal isOpen={addCertificateModal} toggle={toggleAddCertificateModal} size='lg'>
                <ModalHeader toggle={toggleAddCertificateModal}>Add New Project Certification</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-3">

                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="startDate" className="form-label">Start Date</Label>
                                    <Flatpickr
                                        className="form-control"
                                        options={{ dateFormat: "Y-m-d" }}
                                        value={formData.startDate}
                                        onChange={(date) => handleDateChange('startDate', date)}
                                        disabled={submittingForm}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="dueDate" className="form-label">Due Date</Label>
                                    <Flatpickr
                                        className="form-control"
                                        options={{ dateFormat: "Y-m-d" }}
                                        value={formData.dueDate}
                                        onChange={(date) => handleDateChange('dueDate', date)}
                                        disabled={submittingForm}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <h5 className='text-danger pb-2'>Select client's subscription</h5>
                                {defaultCertificate && defaultCertificate.map((certificate, key) => (
                                    <div className="form-check mb-2" key={key}>
                                        {certificate.status === 'ACTIVE' ? (
                                            <Input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`certificate-${key}`}
                                                checked={true}
                                                disabled={true}
                                            />
                                        ) : (
                                            <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="inactiveCertificates"
                                                id={`certificate-${key}`}
                                                onChange={() => handleRadioChange(certificate.id)}
                                                checked={formData.versionId === certificate.id}
                                            />
                                        )}
                                        <Label className="form-check-label" htmlFor={`certificate-${key}`}>
                                            {certificate.certificationType} {""} {certificate.certificationVersion} ({certificate.status})
                                        </Label>
                                    </div>
                                ))}
                            </Col>

                            <Col lg={12}>
                                {
                                    submittingForm ? <Button color="primary" className="me-2" type='button' disabled>
                                        <Spinner size="sm"> Loading... </Spinner> </Button> : <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={handleSubmit}> Add  </Button>
                                }
                                <Button type="button" color="secondary" onClick={handleReset} disabled={submittingForm}>
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
}